import axios from 'axios';

export function getMailRecognizeSpamList() {
    return axios({
        method: 'get',
        url: `/api/v1/admin/preferences/singleByType/mailRecognizeSpamList`,
        withCredentials: true,
    })
        .then(response => response)
        .catch((error) => {
            if (error.response.status === 404) {
               return createMailRecognizeSpamList([]);
            }

            throw error;
        });
}

export function createMailRecognizeSpamList(data) {
    return axios({
        method: 'post',
        url: `/api/v1/admin/preferences/mailRecognizeSpamList`,
        withCredentials: true,
        data,
    })
        .then(response => response)
        .catch(error => error);
}

export function updateMailRecognizeSpamList(data) {
    return axios({
        method: 'put',
        url: `/api/v1/admin/preferences/mailRecognizeSpamList/append`,
        headers: {
            'Content-Type': 'text/plain',
             },
        data,
    })
        .then(response => response)
        .catch(error => error);
}



// WEBPACK FOOTER //
// ./app/services/preferences/mailRecognizeSpamList.js